export function isAssets( url: string ): boolean {
   const substr = url.substring( 0, url.indexOf( '/' ));

   return substr === 'assets';
}

export function isFullUrl( url: string ): boolean {
   const regex = /^(http:|https:)/;

   return regex.test( url );
}
